import React, {useEffect, useState} from "react";
import {Box, Button, CardContent, Tab, Tabs} from "@mui/material";
import PageLayout from "../components/layout/PageLayout";
import {useDispatch, useSelector} from "react-redux";
import {AddCircle, CreateNewFolder, Delete, TableRows} from "@mui/icons-material";
import Wallet from "../components/entry/Wallet";
import EditWalletForm from "../components/form/EditWalletForm";
import EditGroupForm from "../components/form/EditGroupForm";
import {fetchWalletsAndGroups, selectActiveGroups, selectActiveRootWallets} from "../store/walletSlice";
import WalletService from "../services/WalletService";
import WalletGroup from "../components/entry/WalletGroup";
import {useNavigate, useSearchParams} from "react-router-dom";
import {StyledTab} from "../components/utils/StyleConstants";
import {fetchCurrencies} from "../store/currencySlice";
import {useTranslation} from "react-i18next";


const WalletsPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const wallets = useSelector(state => selectActiveRootWallets(state));
    const groups = useSelector(state => selectActiveGroups(state));
    const [selectedWallet, setSelectedWallet] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    // const [resetTrigger, setResetTrigger] = useState(Date.now());
    const [type, setType] = useState('ALL');


    useEffect(() => {
        dispatch(fetchWalletsAndGroups());
        dispatch(fetchCurrencies())
    }, []);

    useEffect(() => {
        console.log("On wallets change")
        let wallet = null;
        const walletIdStr = searchParams.get("wallet");
        if(walletIdStr != null) {
            const walletId = Number(walletIdStr);

            wallet = wallets && wallets.find(eachWallet => eachWallet.id === walletId);
            if(!wallet) {
                groups && groups.forEach(group => {
                    group.balances && group.balances.forEach(eachWallet => {
                        if(eachWallet.id === walletId) {
                            wallet = eachWallet;
                        }
                    })
                })
            }
            // if(selectedWallet !== wallet) {
            // setResetTrigger(new Date());
            if(wallet && selectedWallet !== wallet) {
                setSelectedWallet(wallet);
            }
            // }
        } else {
            if(selectedWallet && selectedWallet.id) {
                setSelectedWallet(null);
            }
        }

        let group = null;
        const groupIdStr = searchParams.get("group");
        if(groupIdStr != null) {
            if(!selectedGroup || selectedGroup.id != groupIdStr) {
                const groupId = Number(groupIdStr);
                group = groups && groups.find(eachGroup => eachGroup.id === groupId);

                if(group) {
                    setSelectedGroup(group)
                }
            }
        } else {
            if(selectedGroup && selectedGroup.id) {
                setSelectedGroup(null);
            }
        }
    }, [wallets, groups, searchParams]);

    const onNewWalletClick = () => {
        clearSelectionWithUrl();
        setSelectedWallet({name: "", image:{id: 1}, balance: "0", type: (type && type != "ALL" ? type : 'WALLET')});
    }
    const onNewGroupClick = () => {
        clearSelectionWithUrl();
        setSelectedGroup({name: "", image:{id: 1}});
    }

    const onWalletClick = (wallet) => {
        clearSelection();
        setSelectedWallet(wallet);
        navigate(`?wallet=${wallet.id}`)
    }

    // const updateState = () => {
    //     setState(newState);
    //
    //     // Обновляем параметры URL без перезагрузки страницы
    //     const params = new URLSearchParams();
    //     if (newState.tab) params.set('tab', newState.tab);
    //     if (newState.filter) params.set('filter', newState.filter);
    //     if (newState.page > 1) params.set('page', newState.page);
    //
    //     navigate(`?${params.toString()}`, { replace: true });
    // };

    const onGroupClick = (group) => {
        clearSelection();
        setSelectedGroup(group);
        navigate(`?group=${group.id}`)
    }

    const clearSelectionWithUrl = () => {
        navigate(`?`);
        clearSelection();
    }

    const clearSelection = () => {
        setSelectedGroup(null);
        setSelectedWallet(null);
        // setResetTrigger(Date.now());
    }

    const onChangeView = () => {

    }

    const tabs = <Tabs value={type} onChange={(event, newValue) => setType(newValue)}
                       aria-label="Wallets types"
                       centered
                       TabIndicatorProps={{
                           style: {
                               color: "white",
                               background: "white"
                           }
                       }}>
        <StyledTab label={t("pages.wallets.tabs.all")} value="ALL" />
        <StyledTab label={t("pages.wallets.tabs.wallets")} value="WALLET" />
        <StyledTab label={t("pages.wallets.tabs.credits")} value="CREDIT" />
        <StyledTab label={t("pages.wallets.tabs.deposits")} value="DEPOSIT" />
        <StyledTab label={t("pages.wallets.tabs.debts")} value="DEBT" />
    </Tabs>

    return (
        <PageLayout
            title={t("pages.wallets.title")}
            tabs={tabs}
            buttons={
                <Button color="inherit" onClick={onNewGroupClick}>
                    <CreateNewFolder />
                </Button>
            }
        >
            <CardContent sx={{minHeight: 200, maxHeight: '90%', overflowY: "auto"}}>
                {WalletService.getActive(wallets, type)
                    .map(
                        (wallet) =>
                            <Wallet key={wallet.id} walletBalance={wallet} onWalletClick={onWalletClick}/>
                    )
                }<br/>
                {groups &&  groups
                    .map(
                        (group) =>
                            <WalletGroup key={group.id} walletGroup={group} onGroupClick={onGroupClick} onWalletClick={onWalletClick} type={type}/>
                    )
                }
                <Box sx={{height: 50}}></Box>

                <Button style={{position: "absolute", bottom: 30, right: "46%", fontSize: "4rem"}}
                        onClick={onNewWalletClick}>
                    <AddCircle fontSize="inherit"/>
                </Button>

            </CardContent>
            {selectedWallet && <EditWalletForm wallet={selectedWallet}
                                                   onCancel={clearSelectionWithUrl}></EditWalletForm>}
            {!selectedWallet && selectedGroup && <EditGroupForm group={selectedGroup}
                                               onCancel={clearSelectionWithUrl}></EditGroupForm>}
        </PageLayout>
    );
}

export default WalletsPage